import { combineReducers } from 'redux'
import { FETCH_STORE_DETAILS_ERROR, FETCH_STORE_DETAILS_SUCCESS } from 'revenue/constants'

import * as constants from './constants'

const details = (state = null, action) => {
  switch (action.type) {
    case constants.TOGGLE_DETAILS:
      return state ? null : action.store
    case constants.CLOSE_DETAILS:
    case constants.CLOSE_SEARCH:
      return null
    default:
      return state
  }
}

const detailsFetching = (state = false, action) => {
  switch (action.type) {
    case constants.CLOSE_SEARCH:
    case FETCH_STORE_DETAILS_SUCCESS:
    case FETCH_STORE_DETAILS_ERROR:
      return false
    default:
      return state
  }
}

const isOpen = (state = false, action) => {
  switch (action.type) {
    case constants.OPEN_SEARCH:
      return true
    case constants.CLOSE_SEARCH:
      return false
    default:
      return state
  }
}

const isFetchingStores = (state = false, action) => {
  switch (action.type) {
    case constants.SEARCH_FOR_STORES:
      return true
    case constants.SEARCH_FOR_STORES_ERROR:
    case constants.SEARCH_FOR_STORES_SUCCESS:
      return false
    default:
      return state
  }
}

const stores = (state = [], action) => {
  switch (action.type) {
    case constants.START_TYPING:
    case constants.SEARCH_FOR_STORES:
      return []
    case constants.SEARCH_FOR_STORES_SUCCESS:
      return action.stores
    default:
      return state
  }
}

const hasFetchError = (state = false, action) => {
  switch (action.type) {
    case constants.SEARCH_FOR_STORES:
      return false
    case constants.SEARCH_FOR_STORES_ERROR:
      return true
    default:
      return state
  }
}

const selectedStores = (state = [], action) => {
  switch (action.type) {
    case constants.CLEAR_ALL:
      return []
    case constants.TOGGLE_ITEM:
      return state.some(store => store.storeId === action.store.storeId)
        ? state.filter(store => store.storeId !== action.store.storeId)
        : [...state, action.store]
    default:
      return state
  }
}

const showSelectedOnly = (state = false, action) => {
  switch (action.type) {
    case constants.TOGGLE_SELECTED:
      return !state
    case constants.CLOSE_SEARCH:
      return false
    default:
      return state
  }
}

const searchInputValue = (state = '', action) => {
  switch (action.type) {
    case constants.SET_SEARCH_INPUT_VALUE:
      return action.value
    default:
      return state
  }
}

const typing = (state = false, action) => {
  switch (action.type) {
    case constants.START_TYPING:
      return true
    case constants.STOP_TYPING:
      return false
    default:
      return state
  }
}

export default combineReducers({
  details,
  detailsFetching,
  hasFetchError,
  isFetchingStores,
  isOpen,
  searchInputValue,
  selectedStores,
  showSelectedOnly,
  stores,
  typing,
})
